/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8c2d6eb88024c38712352d04f728e99a0397d794";
